import Vue from 'vue'
import Vuex from 'vuex'
import {
  currentWork,
  layout,
  libraryData,
  likeWorks,
  pageStack,
  user,
  workHeader,
  album,
  audioPlayer,
  libraryCount,
  checkPc,
  userMsg,
  navControl,
  site
} from './modules'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    currentWork,
    layout,
    libraryData,
    likeWorks,
    pageStack,
    user,
    workHeader,
    album,
    audioPlayer,
    libraryCount,
    checkPc,
    userMsg,
    navControl,
    site
  }
})


export default store



// WEBPACK FOOTER //
// ./src/store/index.js